import { FC } from 'react';

export const AppLayout: FC = () => {
  return (
    <>
      <div id="w2layout-root" style={{ position: 'absolute', height: '100%', width: '100%' }} />

      <div id="left-panels" className="resizablePanelContainer left">
        <div id="tree_library" className="resizablePanel tree-view">
          <form id="tl_search">
            <div className="tree-title">
              <button className="title-prefix-icon tree-title-button" type="button"><i className="fe icon-chevrons-up"></i></button>
              <span className="tree-title-text"></span>
              <button className="form-button square" type="button">+</button>
            </div>
            <div>
              <i className="fe icon-search input-prefix-icon"></i>
              <i className="fe icon-x input-suffix-icon clear-button"></i>
              <input type="search" id="tl_q" className="form-component v-marginal search"/>
            </div>
          </form>
          <div id="tl_container" className="tree-container">
          </div>
        </div>
        <div id="tree_member" className="resizablePanel tree-view">
          <form id="tm_search">
            <div className="tree-title">
              <button className="title-prefix-icon tree-title-button" type="button"><i className="fe icon-chevrons-up"></i></button>
              <span className="tree-title-text"></span>
              <button className="form-button square" type="button">+</button>
            </div>
            <div>
              <i className="fe icon-search input-prefix-icon"></i>
              <i className="fe icon-x input-suffix-icon clear-button"></i>
              <input type="search" id="tm_q" className="form-component v-marginal search"/>
            </div>
          </form>
          <div id="tm_container" className="tree-container"></div>
        </div>
      </div>

      <div id="right-panels" className="resizablePanelContainer right">
        <div id="property_panel" className="resizablePanel property-panel-widget"></div>
      </div>

      <div className='preview_wrapper'>
        <div className='preview_container'></div>
      </div>
      <div className='link_wrapper'>
        <div className='link_container'></div>
      </div>
      <div className='context_menu'></div>

      <div className="designer-version-container"></div>
    </>
  );
};
